export enum EBitfLoaderAction {
  SHOW = 'show',
  HIDE = 'hide',
}
